import React from "react";
import { StyledButton, ButtonVariant, ButtonSize } from "./styles";

interface ButtonProps {
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  full?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  type?: "button" | "submit";
}

export default function Button({
  children,
  variant = "primary",
  size = "md",
  full,
  disabled,
  onClick,
  style,
  type = "button",
}: ButtonProps) {
  return (
    <StyledButton
      type={type}
      $variant={variant}
      $size={size}
      $full={full}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {children}
    </StyledButton>
  );
}
